fragment ImageCategorizationFragment on Image {
  id
  types
  date
  organized
}
